import send, { sendLottery, sendWsLottery } from './index';

export const LotteryService = {
    // 获取所有彩种
    getAllLotteryTypeList(params = {}) {
        return sendLottery({ params, url: '/lottery/category/findAll' });
    },
    // 根据彩种 获取游戏
    getLotteryGame(params: any = {}) {
        return sendWsLottery({ params, url: `/official/lottery/game/findList/${params?.categoryId}` });
    },
    // 根据彩种 获取游戏赔率
    getLotteryGamePlay(params: any = {}) {
        return sendLottery({ params, url: `/lottery/odds/${params?.playId}` });
    },
    // 获取当前期号信息
    getLotteryOpenCode(params: any = {}) {
        return sendLottery({ params, url: `/lottery/issue/current/${params?.gameId}` });
    },
    //投注
    getLotteryBetSubmit(data: any = {}) {
        return send({ data, url: '/game/gameLottery/submit', method: 'POST' });
    },
    // 获取用户的平台列表
    getPlatformList(params = {}) {
        return send({ params, url: '/game/getChessPlatform' });
    },
    // 获取系统公告(滚动)
    getNoticeList(data: any) {
        return send({
            data,
            url: `/content/contentNotice/noticeListByType/${data?.page}/${data?.rows}`,
            method: 'POST',
        });
    },
    // 获取开奖信息
    getIssueResult(params: any = {}) {
        return sendLottery({
            params,
            url: `/lottery/issueResult/${params?.gameId}/${params?.playId}/${params?.current}/${params?.size}`,
        });
    },
    // 获取100期投注助手
    getIssueResultHelper(params: any = {}) {
        return sendLottery({ params, url: `/lottery/bet/helper/${params?.playCode}/${params?.gameCode}` });
    },
    // 获取最新的开奖信息
    getNewOpenCode(params: any = {}) {
        return sendLottery({ params, url: `/lottery/result/newest/${params?.gameId}` });
    },
    // 获取玩法
    getPlayInfo(params: any = {}) {
        return sendLottery({ params, url: `/lottery/play/${params?.gameId}` });
    },
    // 获取中奖详情
    getTopWin(params: any = {}) {
        return sendLottery({ params, url: `/lottery/category/findAll/winTop/${params?.size}` });
    },
};
